export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70540fa23353712557a882001428984320591a8b44&name=pushAdClickData!'